import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { HomeIcon, AwardIcon, AccessibilityIcon, MapPinIcon } from 'lucide-react';
export function WhyNTA() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="about" className="py-20 md:py-28 bg-white" data-id="element-431">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" ref={ref} data-id="element-432">
        {/* Section header */}
        <motion.div className="text-center max-w-4xl mx-auto mb-14 md:mb-16" initial={{
        opacity: 0,
        y: 24
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-433">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-navy-950 font-heading tracking-tight" data-id="element-434">
            Why Families Choose NTA
          </h2>
          <p className="mt-4 text-lg text-ink-muted leading-relaxed" data-id="element-435">
            More than a martial arts school — a community built on respect,
            mentorship, and family values.
          </p>
        </motion.div>

        {/* Benefit grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10 max-w-4xl mx-auto" data-id="element-436">
          {/* Family-Focused */}
          <motion.div className="flex gap-5" initial={{
          opacity: 0,
          y: 24
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.1
        }} data-id="element-437">
            <div className="shrink-0 w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center" data-id="element-438">
              <HomeIcon className="w-6 h-6 text-amber" data-id="element-439" />
            </div>
            <div data-id="element-440">
              <h3 className="text-lg font-bold text-navy-950 font-heading" data-id="element-441">
                Family-Focused Environment
              </h3>
              <p className="mt-2 text-sm text-ink-muted leading-relaxed" data-id="element-442">
                A welcoming atmosphere where parents and children feel at home.
                Our instructors serve as mentors — building relationships with
                every family that walks through our doors.
              </p>
            </div>
          </motion.div>

          {/* Expert Instruction */}
          <motion.div className="flex gap-5" initial={{
          opacity: 0,
          y: 24
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.2
        }} data-id="element-443">
            <div className="shrink-0 w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center" data-id="element-444">
              <AwardIcon className="w-6 h-6 text-amber" data-id="element-445" />
            </div>
            <div data-id="element-446">
              <h3 className="text-lg font-bold text-navy-950 font-heading" data-id="element-447">
                Expert Instruction
              </h3>
              <p className="mt-2 text-sm text-ink-muted leading-relaxed" data-id="element-448">
                Experienced Taekwondo instructors who know how to teach every
                age group — from preschoolers taking their first steps on the
                mat to adults seeking a real challenge.
              </p>
            </div>
          </motion.div>

          {/* Inclusive Programs */}
          <motion.div className="flex gap-5" initial={{
          opacity: 0,
          y: 24
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.3
        }} data-id="element-449">
            <div className="shrink-0 w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center" data-id="element-450">
              <AccessibilityIcon className="w-6 h-6 text-amber" data-id="element-451" />
            </div>
            <div data-id="element-452">
              <h3 className="text-lg font-bold text-navy-950 font-heading" data-id="element-453">
                Inclusive Programs
              </h3>
              <p className="mt-2 text-sm text-ink-muted leading-relaxed" data-id="element-454">
                Our Spectrum Skillz program and Special Olympics connection
                provide adaptive classes for neurodiverse students. Everyone
                belongs at NTA.
              </p>
            </div>
          </motion.div>

          {/* Community Roots */}
          <motion.div className="flex gap-5" initial={{
          opacity: 0,
          y: 24
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.4
        }} data-id="element-455">
            <div className="shrink-0 w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center" data-id="element-456">
              <MapPinIcon className="w-6 h-6 text-amber" data-id="element-457" />
            </div>
            <div data-id="element-458">
              <h3 className="text-lg font-bold text-navy-950 font-heading" data-id="element-459">
                Community Roots
              </h3>
              <p className="mt-2 text-sm text-ink-muted leading-relaxed" data-id="element-460">
                Proudly serving Hurst, Colleyville, Bedford, Euless, and North
                Richland Hills since 2008. We're your neighbors, and we're
                invested in this community.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}